export default "__VITE_ASSET__DvGjLBP6__"